// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__2njmq","button":"Error_button__2lOdf"};